"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _hexToRGBA = _interopRequireDefault(require("../../utils/hexToRGBA"));
var _UIElementSizesEnum = require("../ts/enums/UIElementSizesEnum");
var _UIElementStatusEnum = require("../ts/enums/UIElementStatusEnum");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const iconTypeMap = {
  [_UIElementStatusEnum.UIElementStatusEnum.Success]: 'check_circle',
  [_UIElementStatusEnum.UIElementStatusEnum.Error]: 'cancel',
  [_UIElementStatusEnum.UIElementStatusEnum.Info]: 'error',
  [_UIElementStatusEnum.UIElementStatusEnum.Warning]: 'watch_later'
};
const defaultProps = {
  title: '',
  description: '',
  type: _UIElementStatusEnum.UIElementStatusEnum.Info,
  show: true,
  width: '100%',
  size: _UIElementSizesEnum.UIElementSizesEnum.Medium,
  styles: '',
  time: 0,
  outlined: true,
  className: ''
};
function Alert(props) {
  const {
    title,
    description,
    type,
    show,
    width,
    size,
    styles,
    time,
    outlined,
    className
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [showAlert, setShowAlert] = (0, _react.useState)(show);
  (0, _react.useEffect)(() => {
    setShowAlert(show);
    if (time && show) {
      const timer = setTimeout(() => setShowAlert(false), time);
      return () => clearTimeout(timer);
    }
  }, [time, show]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    width: width,
    show: showAlert,
    type: type,
    size: size,
    styles: styles,
    outlined: outlined,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconTypeMap === null || iconTypeMap === void 0 ? void 0 : iconTypeMap[type === null || type === void 0 ? void 0 : type.toLowerCase()],
    size: 28,
    datasets: {
      'data-alert-icon': true
    }
  }), /*#__PURE__*/_react.default.createElement(Content, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "default",
    weight: 700,
    size: 14,
    children: title
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "default",
    size: 12,
    children: description
  })), /*#__PURE__*/_react.default.createElement(OpacityCanceler, {
    type: type,
    outlined: outlined
  }));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 10px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  overflow: hidden;\n\n  [data-alert-icon='true'] {\n    z-index: 1;\n  }\n\n  ", "\n\n  ", "\n"])), _ref => {
  var _colors$MAIN, _colors$FONT;
  let {
    type,
    theme,
    show,
    width,
    size,
    outlined
  } = _ref;
  if (!show) return 'display: none;';
  const {
    colors
  } = theme;
  const color = colors === null || colors === void 0 || (_colors$MAIN = colors.MAIN) === null || _colors$MAIN === void 0 ? void 0 : _colors$MAIN[String(type).toUpperCase()];
  let style = "\n      *, [data-alert-icon='true'] {\n        color: ".concat(outlined ? color : colors === null || colors === void 0 || (_colors$FONT = colors.FONT) === null || _colors$FONT === void 0 ? void 0 : _colors$FONT.CONTRAST, " !important;\n      }\n\n      @media screen and (min-width: 768px) {\n        .material-icons {\n          font-size: 40px;\n        }\n\n        p {\n          line-height: normal;\n        }\n      }\n    ");
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Small) {
    var _String, _String2;
    style += "\n        border-radius: 6px;\n        height: 25px;\n        padding: 6px;\n\n        .".concat(iconTypeMap === null || iconTypeMap === void 0 ? void 0 : iconTypeMap[(_String = String(type)) === null || _String === void 0 ? void 0 : _String.toLowerCase()], " {\n          font-size: 12px;\n        }\n\n        @media screen and (min-width: 768px) {\n          height: 38px;\n          border-radius: 10px;\n          padding: 10px 15px;\n          gap: 8px;\n\n          .").concat(iconTypeMap === null || iconTypeMap === void 0 ? void 0 : iconTypeMap[(_String2 = String(type)) === null || _String2 === void 0 ? void 0 : _String2.toLowerCase()], " {\n            font-size: 18px;\n          }     \n        }\n      ");
  }
  style += "\n      width: ".concat(width, ";\n      color: ").concat(color, ";\n      background-color: ").concat(colors.NEUTRAL.BACKGROUND, ";\n      border: 1px solid ").concat(color, ";\n    ");
  return style;
}, _ref2 => {
  let {
    styles
  } = _ref2;
  return styles;
});
const Content = _styled.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  z-index: 1;\n\n  ", "\n"])), _ref3 => {
  let {
    size
  } = _ref3;
  let style = "\n      @media screen and (min-width: 768px) {\n        padding: 5px 0;\n        p:first-of-type {\n          font-size: 18px;\n                line-height: normal;\n        }\n          \n        p:last-of-type {\n          font-size: 16px;\n        }\n      }\n    ";
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Small) {
    style += "\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        p:first-of-type {\n          font-size: 10px;\n        }\n\n        p:last-of-type {\n          font-size: 8px;\n        }\n\n        @media screen and (min-width: 768px) {\n          p:first-of-type {\n            font-size: 14px;\n          }\n            \n          p:last-of-type {\n            font-size: 12px;\n          }\n        }\n      ";
  }
  return style;
});
const OpacityCanceler = _styled.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  ", "\n"])), _ref4 => {
  var _theme$colors;
  let {
    outlined,
    theme,
    type
  } = _ref4;
  const color = theme === null || theme === void 0 || (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.MAIN[String(type).toUpperCase()];
  return "background-color: ".concat(outlined ? (0, _hexToRGBA.default)(color, 0.1) : color);
});
var _default = exports.default = Alert;